import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { Router } from 'src/router';

import { persister, queryClient } from './api/client';
import { GlobalModals } from './components/GlobalModals/GlobalModals';
import { SessionManager } from './components/SessionManager';
import { isProduction } from './config';
import { GlobalModalsProvider } from './contexts';
import { theme } from './theme';

const App = () => (
  <PersistQueryClientProvider
    client={queryClient}
    persistOptions={{ persister }}
  >
    <MantineProvider
      defaultColorScheme="dark"
      theme={theme}
      classNamesPrefix="Playwall"
    >
      <GlobalModalsProvider>
        <Router />
        <GlobalModals />
        <Notifications limit={3} />
        <SessionManager />
      </GlobalModalsProvider>
    </MantineProvider>
    {!isProduction && <ReactQueryDevtools initialIsOpen={true} />}
  </PersistQueryClientProvider>
);

export default App;
